
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ls-onsell-progress',
  templateUrl: './onsell-progress.component.html',
  styleUrls: ['./onsell-progress.component.scss']
})
export class OnsellProgressComponent {
  @Input() message: string;
  @Input() title: string;

  constructor(public activeModal: NgbActiveModal) {}
}